export default "__VITE_ASSET__CTVgrxkZ__"